import {ComponentData} from "../../engine/tools/EntityManager";

export type ResourceId = string

export class ImageRenderer implements ComponentData {
    sprite: ResourceId

    constructor(resource: ResourceId = null) {
        this.sprite = resource
    }

}